import { useT } from '@spotify-internal/i18n-core';

export const useShareButtonsCopy = () => {
  const t = useT();

  // Use provided copy or fallback to translations
  return {
    share: t(
      'FRODOR_f92bd3',
      'Share this story',
      'Share refers to sharing on social media',
    ),
    shareTitle: t(
      'FRODOR_e7365a',
      'Spotify for Artists helps you to develop the fanbase you need to reach your goals.',
      '',
    ),
    facebookShareLabel: t(
      'FRODOR_SHARE_FACEBOOK',
      'Share on Facebook',
      'Link to share current page on Facebook',
    ),
    twitterShareLabel: t(
      'FRODOR_SHARE_TWITTER',
      'Share on Twitter',
      'Link to share current page on Twitter',
    ),
    copyLinkLabel: t(
      'FRODOR_SHARE_COPY_LINK',
      'Copy link to clipboard',
      'Link to copy current page URL to clipboard for sharing',
    ),
  };
};
